import Pressable from '@/components/motion/pressable';
import { cn } from '@/lib/utils';
import { AlertCircleIcon } from 'lucide-react';

interface SenderCalloutProps {
	children: string;
	onClick?: () => void;
	tone?: 'primary' | 'warning';
}

export default function SenderCallout({ children, onClick, tone = 'primary' }: SenderCalloutProps) {
	const body = (
		<div
			className={cn(
				'flex items-center gap-2 rounded-xl border px-3 py-2.5 text-[15px]',
				tone === 'primary' && 'border-primary/30 bg-primary/5 text-primary',
				tone === 'warning' && 'border-chart-4/30 bg-chart-4/10 text-chart-4',
			)}
		>
			<AlertCircleIcon size={18} className='shrink-0' />
			<span className='min-w-0 flex-1 text-left'>{children}</span>
		</div>
	);
	if (!onClick) return body;
	return (
		<Pressable role='button' tabIndex={0} onClick={onClick} className='w-full text-left'>
			{body}
		</Pressable>
	);
}
